import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'auditLoadData', method: 'GET', token: token })
}
